module.exports = __webpack_public_path__ + "static/img/commodity_phone_size.06ada3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/commodity_phone_size.png
// module id = g0ff
// module chunks = 128